module.exports = " <div class=row> <div class=col-md-12> <awards-new></awards-new> <awards-list></awards-list> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/AwardsHome.vue
 ** module id = 300
 ** module chunks = 1
 **/